/* eslint-disable react/jsx-indent */
import React, { useState, useCallback, useEffect } from 'react'
import moment from 'moment'
import { Formik, Form, Field } from 'formik'
import { useModal } from 'react-modal-hook'
import { useSelector } from 'react-redux'
import Loading from 'custom/assets/loaders/Loading'
import Modal from '../../../../components/Modal/Modal'
import { carouselCurrentItemSelector, getFeatureListSelector } from '../../../../selectors'
import RequestService from '../../../../services/requests.service'
import { StopChequePaymentSchema } from '../../../../schemas/requests'
import InputError from '../../../../components/InputError/InputError'
import NeoButton from '../../../../components/NeoButton/NeoButton'
import NeoOTP from '../../../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../../../components/FormComponents/NeoSuccess'
import NeoInput from '../../../../components/NeoInput/NeoInput'
import { useHistory } from 'react-router-dom'
import LayoutWithAccountCard from '../../../../layout/Layout/layout-account-card'
import BackArrow from 'custom/assets/common-icons/back-arrow.svg'
import AccountDisplay from '../../../../components/account-display/account-display'
import { useTranslation } from 'react-i18next'
import { REQUESTS_KEYS, DIALOG_KEYS, SIDENAV_KEYS, VALIDATION_MESSAGES } from '../../../../utils/translation-constants'

import validationConfig from 'custom/config/validation.config.json'
import TermsAndCondition from '../../../../components/TermsAndConditions/TermsAndCondition'
const chequeBookConfig = validationConfig['OtherService']['stopCheque']

const todayDate = new Date().toISOString().split('T')[0]

function StopChequePayment() {
  const [stage, setStage] = useState(1)
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [otp, setOtp] = useState('')
  const { t } = useTranslation()
  const history = useHistory()
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const featureList = useSelector(getFeatureListSelector)
  const featureDetails = featureList['CHEQUE_STATUS']
  // const reasonList = [
  //   {
  //     value: 'Lost',
  //   },
  //   {
  //     value: 'Stolen',
  //   },
  // ]
  const [formValues, setFormValues] = useState({
    rangeOfCheques: 'INDIVIDUAL',
    accountNumber: '',
    chequeNumber: '',
    reason: '',
    effectiveDate: '',
    startChequeNumber: '',
    endChequeNumber: '',
    remarks: '',
  })
  const [reasonList, setResonList]=useState([])
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{message?.code}</b> : {message?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(DIALOG_KEYS.CLOSE)}
              onClick={() => {
                hideModal()
                // history.push('/requests')
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  useEffect(()=>{
    getStopChequeReasonList()
  },[])

  const getStopChequeReasonList=useCallback(async()=>{
    try{
      setLoading(true)
      let response=await RequestService.getStopChequeReasonList()
      if(response.status===200){
        setResonList(response.data["stopChequeReason"])
        setLoading(false)
      }
      console.log(response)
    }catch(err){
      setLoading(false)
    }
  },[])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return (
          <NeoOTP loading={loading} otp={otp} setOTP={setOtp} onSubmit={confirmStopChequeBook} />
        )
      case 4:
        return <NeoSuccess message={message} linkPath='/requests' />
      default:
        return renderForm()
    }
  }

  const submitStopChequePaymentForm = useCallback(
    async (data, { setSubmitting }) => {
      try {
        // const featureDetails = featureList['CHEQUE_STOP']
        // if (featureDetails[currentAccountDetail['accountType']] === 'N') {
        //   setMessage({
        //     code: t(DIALOG_KEYS.NO_ACCESS),
        //     message: t(DIALOG_KEYS.NO_ACCOUNTS),
        //   })
        //   showModal()
        //   return
        // }

        setSubmitting(true)
        setFormValues(data)
        const response =
          data.rangeOfCheques === 'INDIVIDUAL'
            ? await RequestService.verifyStopChequePayment({
                accountNumber: currentAccountDetail?.accountNo,
                chequeEndNumber: data.chequeNumber,
                chequeStartNumber: data.chequeNumber,
                effectiveDate: data.effectiveDate,
                reason: data.reason,
                requestType: 'Individual Cheque',
                branchCode: currentAccountDetail?.brnCode,
                remarks: data.remarks,
              })
            : await RequestService.verifyStopChequePayment({
                accountNumber: currentAccountDetail?.accountNo,
                chequeEndNumber: data.endChequeNumber,
                chequeStartNumber: data.startChequeNumber,
                effectiveDate: data.effectiveDate,
                reason: data.reason,
                requestType: 'Range of Cheques',
                branchCode: currentAccountDetail?.brnCode,
                remarks: data.remarks,
              })
        if (response.status === 200) {
          setSubmitting(false)
          // if (response.data['otpEnable']) {
          setOtpEnabled(response.data['otpEnable'])
          setLoading(false)
          setStage(2)
          // return
          // }
          // await confirmStopChequeBook()
        }
      } catch (err) {
        setSubmitting(false)
      }
    },
    [currentAccountDetail, featureList],
  )

  const confirmStopChequeBook = useCallback(async () => {
    try {
      setLoading(true)
      const response =
        formValues.rangeOfCheques === 'INDIVIDUAL'
          ? await RequestService.stopChequePayment({
              accountNumber: currentAccountDetail?.accountNo,
              chequeStartNumber: formValues.chequeNumber,
              chequeEndNumber: formValues.chequeNumber,
              effectiveDate: formValues.effectiveDate,
              otp,
              reason: formValues.reason,
              requestType: 'Individual Cheque',
              branchCode: currentAccountDetail?.brnCode,
              remarks: formValues.remarks,
            })
          : await RequestService.stopChequePayment({
              accountNumber: currentAccountDetail?.accountNo,
              chequeStartNumber: formValues.startChequeNumber,
              chequeEndNumber: formValues.endChequeNumber,
              effectiveDate: formValues.effectiveDate,
              otp,
              reason: formValues.reason,
              requestType: 'Range of Cheques',
              branchCode: currentAccountDetail?.brnCode,
              remarks: formValues.remarks,
            })
      if (response.status === 200) {
        setMessage(response.data['message'])
        setStage(4)
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
      setOtp('')
    }
  }, [formValues, otp, currentAccountDetail])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>
          {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.TITLE)}
        </div>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <Formik
          initialValues={formValues}
          validationSchema={StopChequePaymentSchema}
          onSubmit={submitStopChequePaymentForm}>
          {({ isSubmitting, values, resetForm, errors, touched, handleChange }) => (
            <Form>
              <div className='form-group my-2'>
                <div className='row justify-content-center mb-3'>
                  <div className='custom-control custom-radio custom-control-inline'>
                    <Field
                      as='input'
                      type='radio'
                      id='individualCheque'
                      name='rangeOfCheques'
                      value='INDIVIDUAL'
                      className='custom-control-input'
                      onClick={resetForm}
                      disabled={isSubmitting}
                    />
                    <label className='custom-control-label' htmlFor='individualCheque'>
                      {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.INDIVIDUAL)}
                    </label>
                  </div>
                  <div className='custom-control custom-radio custom-control-inline'>
                    <Field
                      as='input'
                      value='RANGE'
                      type='radio'
                      id='isChequeRange'
                      name='rangeOfCheques'
                      className='custom-control-input'
                      onClick={resetForm}
                      disabled={isSubmitting}
                    />
                    <label className='custom-control-label' htmlFor='isChequeRange'>
                      {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.RANGE)}
                    </label>
                  </div>
                </div>
                <div className='row'>
                  {values.rangeOfCheques === 'INDIVIDUAL' ? (
                    <div className='form-group col-12'>
                      <NeoInput
                        tabIndex='1'
                        showAsterisk={chequeBookConfig['isChequeNumberRequired']}
                        disabled={isSubmitting}
                        text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.CHEQUE_NUMBER)}
                        onChange={handleChange}
                        name='chequeNumber'
                        value={values.chequeNumber}
                      />
                      <InputError text={errors.chequeNumber} touched={touched.chequeNumber} />
                    </div>
                  ) : (
                    <>
                      <div className='form-group col-12'>
                        <NeoInput
                          tabIndex='1'
                          showAsterisk={chequeBookConfig['isStartChequeNoRequired']}
                          text={t(
                            REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.START_CHEQUE_NUMBER,
                          )}
                          onChange={handleChange}
                          name='startChequeNumber'
                          disabled={isSubmitting}
                          value={values.startChequeNumber}
                        />
                        <InputError
                          text={errors.startChequeNumber}
                          touched={touched.startChequeNumber}
                        />
                      </div>
                      <div className='form-group col-12'>
                        <NeoInput
                          tabIndex='2'
                          showAsterisk={chequeBookConfig['isEndChequeNoRequired']}
                          text={t(
                            REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.END_CHEQUE_NUMBER,
                          )}
                          onChange={handleChange}
                          name='endChequeNumber'
                          disabled={isSubmitting}
                          value={values.endChequeNumber}
                        />
                        <InputError
                          text={errors.endChequeNumber}
                          touched={touched.endChequeNumber}
                        />
                      </div>
                    </>
                  )}
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    <label>
                      {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REASON)}{' '}
                      {chequeBookConfig['isReasonRequired'] ? '*' : ''}
                    </label>
                    <Field
                      tabIndex={'3'}
                      as='select'
                      name='reason'
                      onChange={handleChange}
                      className='form-control'>
                      <option value='' disabled defaultValue />
                      {reasonList.map((opt, i) => (
                        <option value={opt} key={i}>
                          {opt}
                        </option>
                      ))}
                    </Field>
                    {/* <NeoInput
                      mode='select'
                      text={t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REASON)}
                      name='reason'
                      onChange={handleChange}
                      list={reasonList}
                      keyValue='value'
                      disabled={isSubmitting}
                      value={values.reason}
                    /> */}
                    <InputError text={errors.reason} touched={touched.reason} />
                  </div>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='4'
                      showAsterisk={chequeBookConfig['isEffectiveDateRequired']}
                      text={t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.EFFECTIVE_DATE)}
                      name='effectiveDate'
                      type='date'
                      onChange={handleChange}
                      min={todayDate}
                      disabled={isSubmitting}
                      value={values.effectiveDate}
                    />
                    <InputError text={errors.effectiveDate} touched={touched.effectiveDate} />
                  </div>
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='5'
                      showAsterisk={chequeBookConfig['isRemarksRequired']}
                      disabled={isSubmitting}
                      text={t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REMARKS)}
                      onChange={handleChange}
                      name='remarks'
                      value={values.remarks}
                      minLength={2}
                      maxLength={40}
                    />
                    <InputError text={errors.remarks} touched={touched.remarks} />
                  </div>
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    {isSubmitting ? (
                      renderLoading()
                    ) : (
                      <NeoButton
                        tabIndex='6'
                        mode='newDesign'
                        type='submit'
                        disabled={isSubmitting}
                        text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.SUBMIT)}
                      />
                    )}
                  </div>
                </div>
                <div className='back-cancel-btn-container'>
                <button className='back-cancel-btn btn btn-sm new-design-warning-text-color' tabIndex={'7'} onClick={() => history.goBack()}>
                  {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
                </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.TITLE)}</h3>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />

        {formValues.rangeOfCheques === 'INDIVIDUAL' ? (
          <div>
            <h6 className='label'>{t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.CHEQUE)}</h6>
            <h6 className='value'>{formValues.chequeNumber}</h6>
          </div>
        ) : (
          <>
            <div>
              <h6 className='label'>
                {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.START_CHEQUE_NUMBER1)}
              </h6>
              <h6 className='value'>{formValues.startChequeNumber}</h6>
            </div>
            <div>
              <h6 className='label'>
                {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.END_CHEQUE_NUMBER1)}
              </h6>
              <h6 className='value'>{formValues.endChequeNumber}</h6>
            </div>
          </>
        )}
        <div>
          <h6 className='label'>{t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REASON1)}</h6>
          <h6 className='value'>{formValues.reason}</h6>
        </div>
        <div>
          <h6 className='label'>
            {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.EFFECTIVE_DATE1)}
          </h6>
          <h6 className='value'>{moment(formValues.effectiveDate).format('DD-MM-YYYY')}</h6>
        </div>
        <div>
          <h6 className='label'>
            {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REMARKS1)}
          </h6>
          <h6 className='value'>{formValues.remarks || '-'}</h6>
        </div>

        <div className='form-group col-12'>
          <TermsAndCondition module='STOPCHEQUEPAYMENT' />
        </div>

        <div className='mt-3'>
          {loading ? (
            renderLoading()
          ) : (
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_KEYS.CONFIRM)}
              onClick={() => (otpEnabled ? setStage(3) : confirmStopChequeBook())}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {' '}
          {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
        </div>
      </div>
    )
  }

  // const stageCallback = useCallback(() => {
  //   const startStage = 1
  //   if (stage === startStage) {
  //     history.goBack()
  //   } else if (startStage) {
  //     const newStage = stage - 1
  //     setStage(newStage)
  //   }
  // }, [stage])

  // function renderBackButton() {
  //   return (
  //     <div
  //       className='mx-2 mb-4 cursor-pointer font-weight-600'
  //       style={{ fontSize: 12, width: 'fit-content' }}
  //       onClick={stageCallback}>
  //       <img className='mr-4' src={BackArrow} />
  //       Back to Cheque Options
  //     </div>
  //   )
  // }

  return (
    <LayoutWithAccountCard breadCumKey='REQUEST_STOP_CHEQUE'>
      {/* <div className='row'>
        <div className='col-7 d-flex'>
          <div>
            <img src={menuDetails.icon} alt='statement icon' />
          </div>
          <div>
            <span className='font-weight-bold'>{menuDetails.title}</span>
            <span className='header-title-section'>
              <p>{menuDetails.desc}</p>
            </span>
          </div>
        </div>
        <div className='col-5 text-right'></div>
      </div>
      {stage !== 4 && stage !== 3 && renderBackButton()} */}
      {featureDetails[currentAccountDetail['accountType']] !== 'N' && (
        <div className='new-design-form-style'>{renderSwitch()}</div>
      )}

      {featureDetails[currentAccountDetail['accountType']] === 'N' && (
        <div className='no-data-found'>{t(VALIDATION_MESSAGES.NO_ACCESS)}</div>
      )}
    </LayoutWithAccountCard>
  )
}

export default StopChequePayment
